export default [{
  path: '/monitoring',
  name: 'monitoring',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/monitoring/index')
}]
